import React from "react";

// styled components
import { Row, Col, Button } from "antd";

interface PropsState {
  doFunction: Function;
}

export const Buttonloadmore: React.FC<PropsState> = (props: PropsState) => {
  return (
    <Row style={{ width: "100%", justifyContent: "center", marginBottom: "16px", marginTop: "16px" }}>
      <Col>
        <Button
          type="link"
          className="form_bg_btn button-azul-radius"
          size="large"
          style={{ padding: '10px', fontWeight:'bold' }}
          onClick={() => {
            props.doFunction()
          }}
        >
          CARGAR MÁS CONVOCATORIAS
        </Button>
      </Col>
    </Row>
  );
};
